import {Box, Typography} from '@mui/material';
import {formatDateString} from '~/utils/helper';
import {styles} from './styles';
interface AppointmentSummaryProps {
  appointment: {
    id: number;
    date: string;
    start_time: string;
    end_time: string;
    sub_care_type_name: string;
    doctor_name: string;
  };
}

export default function AppointmentSummary({
  appointment,
}: AppointmentSummaryProps) {
  const formatTime = (timeString: string) => {
    const date = new Date(timeString);
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  return (
    <Box sx={styles.container}>
      <Typography variant="h6" sx={styles.title}>
        Appointment summary:
      </Typography>

      <Box sx={styles.detailContainer}>
        <Box sx={styles.row}>
          <Typography sx={styles.label}>Appointment</Typography>
          <Typography sx={styles.value}>
            {appointment.sub_care_type_name}
          </Typography>
        </Box>

        <Box sx={styles.row}>
          <Typography sx={styles.label}>Consultant</Typography>
          <Typography sx={styles.value}>{appointment.doctor_name}</Typography>
        </Box>

        <Box sx={styles.row}>
          <Typography sx={styles.label}>Date</Typography>
          <Typography sx={styles.value}>
            {formatDateString(appointment.date)}
          </Typography>
        </Box>

        <Box sx={styles.row}>
          <Typography sx={styles.label}>Time</Typography>
          <Typography sx={styles.value}>
            {formatTime(appointment.start_time)}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
